export enum MixpanelRecommendationUserAction {
    Accepted = 'accepted',
    Declined = 'declined'
}
